export enum ClvrScreenControlWindowCategory {
    SMALL = 'SMALL',
    MEDIUM = 'MEDIUM',
    BIG = 'BIG'
}

// allows you to know the categories of the screen according to its size
export enum ClvrScreenControlWindowSize {
    SMALL = 800, // 0 -> 800
    MEDIUM = 801, // 801 -> 1099
    BIG = 1100 // 1100 -> n
}

export enum ClvrScreenControlTrSizeByCategory {
    SMALL = 55,
    MEDIUM = 75,
    BIG = 95
}
